import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useStatsig } from '../../hooks/useStatsig';
import styles from './referralProfileBanner.scss';

const ReferralProfileBanner = ({ 'data-testid': dataTestId }) => {
    const { checkGate, featureGates } = useStatsig();

    if (!checkGate(featureGates.REFERRAL_SYSTEM) || !checkGate(featureGates.POWER_REFERRAL_BANNER)) {
        return null;
    }

    return (
        <div className={styles.banner} data-testid={dataTestId && `${dataTestId}.container`}>
            <span className={styles.text} data-testid={dataTestId && `${dataTestId}.text`}>Level up Together.</span>
            <Link to="/refer-friends/member" className={styles.cta} data-testid={dataTestId && `${dataTestId}.cta`}>
                Refer a Friend
            </Link>
        </div>
    );
};

ReferralProfileBanner.propTypes = {
    'data-testid': PropTypes.string,
};

ReferralProfileBanner.defaultProps = {
    'data-testid': null,
};

export default ReferralProfileBanner;
